import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { useLocation, useParams } from "react-router";
import { ToastContainer, toast } from "react-toastify";
import Badge from "@mui/material/Badge";
import { RoleContext } from "../RoleContext";
import { Link } from "react-router-dom";
import { Button } from "react-bootstrap";
import Table from "../Theme/Table";
import Spinner from "../Spinner";
function SubAgentRegisteredDrivers() {
  const edit = "driver";
  const detail = "viewDriver";

  let [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);
  const location = useLocation();
  const [drivers, setDrivers] = useState([]);
  const [id, setId] = useState(null);

  const [deleteMessage, setDeleteMessage] = useState(null);
  const [displayAddModal, setDisplayAddModal] = useState(false);
  const [displayConfirmationModal, setDisplayConfirmationModal] =
    useState(false);

  const params = useParams();
  const ids = params.id;
  const roleData = useContext(RoleContext);
  var role = JSON.parse(roleData);

  const [displayAddCreditModal, setDisplayAddCreditModal] = useState(false);
  const showAddCreditModal = (id) => {
    setId(id);

    axios.get("/driver/" + id, {}).then((res) => {
      setData(res.data.driver);
      setDisplayAddCreditModal(true);
    });
  };

  const [displayEditModal, setDisplayEditModal] = useState(false);
  const hideEditModal = () => {
    setDisplayEditModal(false);
  };

  const showAddModal = () => {
    setDisplayAddModal(true);
  };

  const showDeleteModal = (id, name) => {
    setId(id);
    setDeleteMessage(`Are you sure you want to delete this driver`);
    setDisplayConfirmationModal(true);
  };
  const showEditModal = (id) => {
    setId(id);

    axios.get("/driver/" + id, {}).then((res) => {
      setData(res.data.driver);
      setDisplayEditModal(true);
    });
  };

  const notify = () =>
    toast.success("Sub agent registered drivers loaded.", {
      position: "top-right",
      autoClose: 1000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  const notifyError = () =>
    toast.error("Something went wrong ...", {
      position: "top-right",
      autoClose: 1000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  useEffect(() => {
    getDrivers();
  }, [location.key]);

  const getDrivers = async () => {
    try {
      const response = await axios
        .get("drivers/bySubAgent/" + ids)
        .then((res) => {
          setDrivers(res.data);
          setLoading(false);
          notify();
        })
        .catch((err) => {
          notifyError();
        });
    } catch (error) {
      notifyError();
    }
  };

  const columns = React.useMemo(
    () => [
      {
        Header: "Name",
        columns: [
          {
            Header: "ID",
            accessor: "id",
          },
          {
            Header: "First Name",
            accessor: "firstName",
          },
          {
            Header: "Last Name",
            accessor: "lastName",
          },
          {
            Header: "Gender",
            accessor: "gender",
          },
        ],
      },
      {
        Header: "Info",
        columns: [
          {
            Header: "Phone",
            accessor: "phoneNumber",
          },
          {
            Header: "Address",
            accessor: "address",
          },
          {
            Header: "Rating",
            accessor: "rating",
          },
          {
            Header: "Balance",
            accessor: "balance",
          },
          {
            Header: "Status",
            accessor: "status",
            disableFilters: true,

            Cell: (row) => (
              <div>
                {(() => {
                  if (row.cell.row.original.status == "Active") {
                    return (
                      <Badge
                        badgeContent={row.cell.row.original.status}
                        color="success"
                      >
                        {" "}
                      </Badge>
                    );
                  } else {
                    return (
                      <Badge
                        badgeContent={row.cell.row.original.status}
                        color="warning"
                      >
                        {" "}
                      </Badge>
                    );
                  }
                })()}
              </div>
            ),
          },
          {
            Header: "Action",
            accessor: "action",
            disableFilters: true,
            Cell: (row) => (
              <div>
                {role.filter(function (e) {
                  return e.perm_name === "add_driver_pocket";
                }).length > 0 && (
                  <Link
                    to={""}
                    onClick={(e) =>
                      showAddCreditModal(row.cell.row.original.id)
                    }
                  >
                    <i className="fas fa-dollar-sign success" />
                  </Link>
                )}
                &nbsp;
                {role.filter(function (e) {
                  return e.perm_name === "edit_driver";
                }).length > 0 && (
                  <Link
                    to={""}
                    onClick={(e) => showEditModal(row.cell.row.original.id)}
                  >
                    <i className="fas fa-edit info" />
                  </Link>
                )}
                &nbsp;
                {role.filter(function (e) {
                  return e.perm_name === "view_driver";
                }).length > 0 && (
                  <Link to={"/" + detail + "/" + row.cell.row.original.id}>
                    <i className="fas fa-eye success" />
                  </Link>
                )}
                &nbsp;
                {role.filter(function (e) {
                  return e.perm_name === "delete_driver";
                }).length > 0 && (
                  <Link
                    to={""}
                    onClick={(e) => showDeleteModal(row.cell.row.original.id)}
                  >
                    <i className="fas fa-trash error" />
                  </Link>
                )}
              </div>
            ),
          },
        ],
      },
    ],
    []
  );

  return (
    <div className="content-wrappers">
      <br />
      <br />
      <ToastContainer />

      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-header">
                  <h3 className="card-title">Sub Agent Registered Drivers</h3>

                  {role.filter(function (e) {
                    return e.perm_name === "add_driver";
                  }).length > 0 && (
                    <Button
                      onClick={() => showAddModal()}
                      className="btn btn-success bt"
                    >
                      Add Driver
                    </Button>
                  )}
                </div>

                <div className="card-body">
                  {loading && (
                    <div>
                      <Spinner />
                    </div>
                  )}
                  {!loading && (
                    <Table
                      columns={columns}
                      data={drivers}
                      edit={edit}
                      detail={detail}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default SubAgentRegisteredDrivers;
